import { FC, ReactNode } from 'react';
import cn from 'classnames';
import styles from './index.module.less';
import { IProdBanner } from '@pro/linearTopLight/interface';
import { PageBanner } from '@app/linearTopLight/PageBanner';

type IProdOverlayBannerProps = {
    className?: string;
    data: { banner: IProdBanner };
    children?: ReactNode;
};

export const ProdOverlayBanner: FC<IProdOverlayBannerProps> = props => {
    const { className, data, children } = props;

    return (
        <div className={cn(className, 'relative')}>
            <PageBanner data={data.banner}/>

            <div className={cn(styles.overlay, 'g-overlay')}>
                {children}
            </div>
        </div>
    )
};
